module.exports = __webpack_public_path__ + "img/Libel-or-Slander.77493a62.png";